module.exports = __webpack_public_path__ + "img/1080_15.c4b2e18a.jpg";